// rmChecklistWshc — STATIC content of the official WSHC RM Audit Checklist (Revision V3.3),
// extracted verbatim from 'bizSAFE level 3 Risk Mgt Audit Checklist 20260701.xlsx'.
// Used ONLY by the WSHC-format printed report (WshcChecklistSection). Auditor screens never import this.
export const WSHC_REVISION = 'V3.3'

export const WSHC_MAIN = [
 {
  "no": "1",
  "title": "Policy",
  "items": [
   {
    "clause": "1.1",
    "question": "Is the policy up to date, signed by the current CEO/ Top Management within top three tier and communicated within the organisation/ company?",
    "dr": "DR & IP",
    "guidance": "Check that CEO/ Top Management has attended the bizSAFE Level 1 workshop \n\nCheck that the policy is up to date and signed by the current CEO/ Top Management\n\nInterview 3 employees to verify if they know where to retrieve the policy and what it means to them",
    "notes": "Attach the CEO/ Top Management(s) training certificate\n\nAttach the policy\n\nAttach the interview checklist"
   }
  ]
 },
 {
  "no": "2",
  "title": "Preparation for hazard identification, risk assessment and risk control",
  "items": [
   {
    "clause": "2.1",
    "question": "Are the appointed RA/ RM team leader(s) competent to carry out Risk Assessment?\n\nNote: Competent team leader(s) must have minimally completed:\n- bizSAFE Level 2 RM Course after Nov 2007; or \n- Workforce Skills Qualification (WSQ) Develop Risk Management Implementation Plan course; or \n- Workforce Skills Qualification (WSQ) Workplace Safety and Health Control Measures course; or\n- WSH-related qualifications courses that meet the requirement to apply as registered WSH Officer.\n\n(Ref: https://www.mom.gov.sg/workplace-safety-and-health/wsh-professionals/workplace-safety-and-health-officer/apply-to-be-a-registered-wsh-officer)",
    "dr": "DR",
    "guidance": "Check that all RA/ RM team leader(s) WSQ bizSAFE Level 2 course certification or its equivalent\n\nCheck that sufficient RA/ RM team leaders and members have been appointed for the company's work activities",
    "notes": "Attach the RA/ RM team leader(s) training certificates"
   },
   {
    "clause": "2.2",
    "question": "Is there an inventory of work activities (covering both routine/ non-routine work activities and new work activity)?",
    "dr": "DR & PI",
    "guidance": "A list of all work activities should have been developed prior to RA. The inventory list should have included all or most of the organisation/ company’s daily operations\n\nWalkthrough the worksite and validate the inventory of work activities",
    "notes": "Attach the inventory of work activities"
   }
  ]
 },
 {
  "no": "3",
  "title": "Risk Assessment: Hazard identification, Risk Evaluation and Risk Control",
  "items": [
   {
    "clause": "3.1",
    "question": "Is there a risk register for organisation/ company work activities?\n\nNote: Risk register is a compilation of risk assessments",
    "dr": "DR",
    "guidance": "Check that the risk register is readily available and maintained at the workplace",
    "notes": "Attach an image/ photo of the risk register"
   },
   {
    "clause": "3.2",
    "question": "Are the top 3 hazards (including at least 1 health hazard) for each work activity identified and recorded in the RA?",
    "dr": "DR & IP",
    "guidance": "Interview RM Champion to check the accident/ injury/ reportable incident/ near miss record to identify the top 3 hazards for each of the 3 selected work activities",
    "notes": "Attach the accident/ injury/ reportable incident/ near miss record and RAs highlighting evidence if applicable\n\nAttach the interview checklist"
   },
   {
    "clause": "3.3",
    "question": "Are the following categories of hazards considered in the RA, where applicable:\n• physical;\n• mechanical;\n• electrical;\n• chemical;\n• biological; and \n• psychosocial",
    "dr": "DR",
    "guidance": "Check 3 RAs for evidence, where at least 2 hazard categories have been considered",
    "notes": "Attach the 3 RAs where at least 2 hazard categories are considered"
   },
   {
    "clause": "3.4",
    "question": "Are risks associated with terrorism threats, disease outbreak (e.g., epidemics, pandemics), and mental well-being considered in the RA?",
    "dr": "DR",
    "guidance": "Check 3 RAs for evidence that organisation/ company update their RM processes to account for:\n- terrorism threat;\n- mitigate infectious disease outbreaks/ transmission; and\n- mental well-being",
    "notes": "Attach 3 RAs where the hazards are considered"
   },
   {
    "clause": "3.5",
    "question": "Are work organisation factors considered in the RA, where applicable?\n\nE.g., excessive workload, prolonged working hours, lack of adequate training, inadequate acclimatisation to hot environment, alienated sub-groups of employees that could place them at risk of self-radicalisation",
    "dr": "DR & IP",
    "guidance": "Check 3 RAs for evidence that work organization factors have been considered",
    "notes": "Attach the 3 RAs highlighting the evidence that work organisation factors have been considered within the RA\n\nAttach the interview checklist"
   },
   {
    "clause": "3.6",
    "question": "Are personal health-risk factors considered in the RA, where applicable?\n\nE.g., physical fitness, personal health condition, conditions that may affect safety critical work (such as chronic diseases), pregnancy, smoking and use of certain medications or alcohol misuse.",
    "dr": "DR & IP",
    "guidance": "Check 3 RAs for evidence that personal health risk factors have been considered",
    "notes": "Attach the 3 RAs highlighting the evidence that personal health risk factors have been considered within the RA\n\nAttach the interview checklist"
   },
   {
    "clause": "3.7",
    "question": "Does the RA consider activities of all persons affected or having access (including contractors and visitors) to the workplace?",
    "dr": "DR",
    "guidance": "Check 3 RAs for evidence",
    "notes": "Attach the 3 RAs highlighting the relevant areas"
   },
   {
    "clause": "3.8",
    "question": "Is the risk level evaluated appropriately/ reasonably determined?",
    "dr": "DR & IP",
    "guidance": "Check 3 RAs to assess if the severity and likelihood are reasonably determined",
    "notes": "Attach the document illustrating how severity and likelihood are determined\n\nShould any severity or likelihood appear unreasonable, highlight the RA entry in the submission\n\nAttach the interview checklist"
   },
   {
    "clause": "3.9",
    "question": "Do the control measures focus on upstream risk control (i.e., elimination, substitution, engineering control)?",
    "dr": "DR & PI",
    "guidance": "Check 3 RAs for evidence of focus on upstream risk control\n\nWalkthrough the workplace to verify that upstream risk controls are implemented on site",
    "notes": "Attach the 3 RAs highlighting upstream risk control implementation (attach an image/ photo/ document, where applicable)"
   },
   {
    "clause": "3.10",
    "question": "Does the RA specify the implementation and due date for each risk control measure?",
    "dr": "DR & IP",
    "guidance": "Check 1 RA and interview the implementation person(s) on the knowledge of their appointment and deadline for the implementation",
    "notes": "Attach the RA and highlight the evidence\n\nAttach the interview checklist"
   },
   {
    "clause": "3.11",
    "question": "Are the completed RAs approved by the Manager* of the work activity?\n\n*Manager: may be the person who manages a/ an\n  - physical area (“Area Manager”, e.g., Warehouse Manager);\n  - function (“Functional Manager”, e.g., Production Manager);\n  - activity (e.g., Machining Manager).",
    "dr": "DR & IP",
    "guidance": "Check 3 RAs for Manager approval and interview the Manager",
    "notes": "Highlight any RA entry where there is no Manager approval in your submission\n\nAttach the interview checklist"
   }
  ]
 },
 {
  "no": "4",
  "title": "Implementation",
  "items": [
   {
    "clause": "4.1",
    "question": "Question for Manager:\nIs the risk control implementation plan followed through?",
    "dr": "DR, PI & IP",
    "guidance": "Check if there is a procedure in place to determine the risk control implementation status or progress\n\nWalkthrough the workplace to check 1 completed and one on-going risk control implementation",
    "notes": "Attach the document describing the process for checking risk control implementation\n\nAttach an image/ photo of the completed and on-going risk control implementation\n\nAttach the interview checklist"
   },
   {
    "clause": "4.2",
    "question": "Question for Implementation Person:\nAre the risk control measures implemented?",
    "dr": "DR, PI & IP",
    "guidance": "Interview 3 implementation persons on their implementation plan\n\nWalkthrough the workplace to check 1 completed and one on-going risk control implementation",
    "notes": "Attach the implementation plan\n\nAttach the interview checklist"
   },
   {
    "clause": "4.3",
    "question": "Are the risk control measures effective in reducing the risk of injury?",
    "dr": "DR, PI & IP",
    "guidance": "Check for evidence that risk controls are assessed after implementation",
    "notes": "Attach the records of post implementation evaluation\n\nAttach the accident/ injury record before and after risk control measure implementation, where applicable\n\nAttach the interview checklist"
   },
   {
    "clause": "4.4",
    "question": "Are RAs for the work activity made easily available to all employees?",
    "dr": "DR, PI & IP",
    "guidance": "Check how RA is made available onsite\n\nInterview 3 employees and get them to show you how they access the correct RAs onsite",
    "notes": "Attach the interview checklist\n\nAttach the RA meetings or email to stakeholders to show that the RA has been effectively communicated"
   },
   {
    "clause": "4.5",
    "question": "Are the employees aware of the onsite hazards and the corresponding risk controls implemented?",
    "dr": "DR, PI & IP",
    "guidance": "Check for communication records, e.g., briefing/ training records, noticeboard messages\n\nWalkthrough the workplace to find evidence of hazard communication. e.g., warning signs, audio visual means of communication\n\nInterview 3 employees to verify their awareness level of the onsite hazards and the risk controls implemented",
    "notes": "Attach the briefing attendance records and interview checklist\n\nAttach an image/ photo of communication/ hazard communication"
   },
   {
    "clause": "4.6",
    "question": "Are there Safe Work Procedures (SWP) implemented for each activity in the list of inventory of work activities?",
    "dr": "DR",
    "guidance": "Pick 3 high/ highest risk work activities and ask for the SWPs",
    "notes": "Attach the 3 SWPs"
   },
   {
    "clause": "4.7",
    "question": "Do the employees adhere to the SWP?",
    "dr": "PI & IP",
    "guidance": "Interview 1 manager, 1 supervisor, 1 worker at the workstation. Find out how the worker obtains the SWP and uses it to carry out the work",
    "notes": "Attach the interview checklist"
   },
   {
    "clause": "4.8",
    "question": "Does the organisation/ company put in place controls to address the possibility of terrorism threat?",
    "dr": "DR, PI & IP",
    "guidance": "Walkthrough the workplace to view the organisation/ company's security implementation, e.g. at the workplace entry/ exit points \n\nInterview 3 employees for their:\ni.) Ability to explain key SGSecure tenets:\n  a. Run, Hide, Tell;\n  b. Press, Tie, Tell.\n\nii.) Awareness of organisation/ company's Emergency Response Plan:\n  a. Emergency evacuation routes; \n  b. Hiding locations in the workplace; and \n  c. What to do during a lockdown procedure.",
    "notes": "Attach the interview checklist and emergency response plan\n\nAttach an image/ photo of the security implementation, only if non-confidential"
   }
  ]
 },
 {
  "no": "5",
  "title": "Review",
  "items": [
   {
    "clause": "5.1",
    "tag": "ALL Application",
    "question": "Is there procedure to review and revise the RA? ",
    "dr": "DR & IP",
    "guidance": "Interview the RM team members and Top Management to verify if they know the criteria to review and revise RA\n\ni.e. at least once every 3 years, or upon the occurrence of any bodily injury to any person as a result of exposure to a hazard in the workplace, or significant change in work practices/ procedure, or significant change in the employee' personal health in relation to safety critical work process or activity, or when new information on WSH risks, threat of terrorism, disease outbreak, or mental well-being is made known",
    "notes": "Attach the procedure to review and revise the RA\n\nAttach the interview checklist\n"
   },
   {
    "clause": "5.2",
    "question": "Are RAs reviewed (and revised, if necessary) at least once every three years?",
    "dr": "DR",
    "guidance": "Check the meeting minutes or correspondence between RM Team and management for evidence of review and approval\n\nWhere practicable, RA should be reviewed annually",
    "notes": "Attach meeting minutes or correspondence of review and approval, if any\n\nAttach the 2 approved RAs that were reviewed and/ or revised",
    "subheader": "Additional questions for Renewal application"
   },
   {
    "clause": "5.3",
    "question": "Are RAs reviewed (and revised, if necessary) where there is occurrence of any bodily injury to any person as a result of exposure to a hazard in the workplace?",
    "dr": "DR",
    "guidance": "Check organisation/ company's accident, incident, near miss and dangerous occurrence records\n\nSelect any 2 of the above and verify if the relevant RAs were revised accordingly",
    "notes": "Attach the summary of the incident report along with the action plan, if any\n\nAttach the 2 RAs and highlight the areas that were revised"
   },
   {
    "clause": "5.4",
    "question": "Are RAs reviewed (and revised, if necessary) where there is a significant change in work practices, or procedures?",
    "dr": "DR",
    "guidance": "Check organisation/ company's records for recent changes (within 3 years) in work practices, procedures, facilities or work environment\n\nSelect at least 1 significant change and check the RA for corresponding revision",
    "notes": "Attach the record of change and at least 1 corresponding RA"
   },
   {
    "clause": "5.5",
    "question": "Are RAs reviewed (and revised, if necessary) where there is new information on WSH emerging risks, threat of terrorism, disease outbreak, or mental well-being is made known?",
    "dr": "DR & IP",
    "guidance": "Find out where/ how the organisation/ company sources for new information\n\nCheck at least 1 RA for evidence of impact of new information",
    "notes": "Attach the new information source and corresponding RA\n\nAttach the interview checklist"
   },
   {
    "clause": "5.6",
    "question": "Are changes to RAs communicated and consulted with external and internal stakeholders, including all functions and levels within the organisation/ company?",
    "dr": "DR & IP",
    "guidance": "Interview 3 employees if they are aware of the changes in the RA. Check for evidence of communication",
    "notes": "Attach the communication and consultation records for different groups within the organisation. e.g., meetings, staff dialogues, trainings, notice boards and various electronic means\n\nNote: Effective communication and consultation involve two-way dialogues between stakeholders\n\nAttach the interview checklist"
   }
  ]
 }
]

export const WSHC_AH = [
 {
  "no": "1",
  "name": "Vehicular Safety",
  "question": "Does your organisation/ company manage vehicular safety?",
  "dr": "DR, PI & IP",
  "guidance": "Ask about the organisation/ company's driver fatigue management programme and traffic management within the workplace\n\nLook for implementation of Vehicular Safety Technology (e.g., fatigue detection, distraction detection, collision detection, speed limiters)\n\nFrom 1 January 2026, a company that owns at least one lorry needs to provide evidence that their lorry(ies) have been installed with speed limiters.\n\nEvidence for speed limiter installation is to get an official invoice from authorised agent for installation or inspection report from vehicle inspection centre that at least one lorry has been installed (no need to check if all lorries are covered); and to do random spot check that lorries on site have official label pasted on lorry windscreen (no need to check all lorries). \n\nOnly tick \"NA\" in column G if the company: \n- Does not have any lorries/drivers, \n- Only has G-plate vehicles,\n- Only has outsourced lorries. \n\nInterview 3 employees to evaluate if rewards & incentives including pay-per-trip remuneration practice has a negative impact on WSH\n\nFor more information on speed limiters, click here.",
  "notes": "Attach the document describing the organisation/ company's fatigue management programme/ plan and traffic management\n\nAttach the evidence of vehicular safety technology implementation. For speed limiters, attach one copy (per company) of the invoice and/or inspection report from the vehicle inspection centre; and photos of the official label from authorised agent for any lorries found on site that were randomly checked.  \n\nAttach the interview checklist"
 },
 {
  "no": "2",
  "name": "Machinery Safety",
  "question": "Does your organisation/ company manage machinery safety?",
  "dr": "DR, PI & IP",
  "guidance": "Walkthrough the workplace to check that machine hazards have been suitably addressed. In particular, check for effective implementation of machine safeguards and Lock-out Tag-out (LOTO) procedure prior to maintenance. Also, check for the use of presence sensors, where applicable\n\nInterview 3 employees on how they carry out the LOTO procedure",
  "notes": "Attach an image/ photo of an effective machine safeguard and/ or a presence sensor\n\nAttach the LOTO procedure\n\nAttach the interview checklist"
 },
 {
  "no": "3",
  "name": "Slips, Trips & Falls (STF)",
  "question": "Does your organisation/ company implement measures to prevent STF?",
  "dr": "DR, PI & IP",
  "guidance": "Walk through the workplace to check for housekeeping issues which can lead to STF hazards\n\nCheck that company-issued safety footwear are placed on a regular inspection and replacement programme\n\nInterview 3 workers to ask what they would they do if they were to spot a STF hazard and when their footwear is worn out",
  "notes": "Attach an image/ photo to show an overview of the worksite/ factory/ premises/ facilities\n\nAttach the evidence on the footwear replacement programme\n\nAttach the interview checklist"
 },
 {
  "no": "4",
  "name": "Work At Height (WAH)",
  "question": "Does your organisation/ company implement risk controls for WAH activities?",
  "dr": "DR, PI & IP",
  "guidance": "Check if Fall Prevention Plan (FPP) is customised to address the unique on-site WAH situations\n\nWalkthrough the workplace to look for secure anchorage points for WAH activities\n\nInterview 3 workers if they are aware of the FPP and location of the anchorage points",
  "notes": "Attach the FPP\n\nAttach an image/ photo of the anchorage points\n\nAttach the interview checklist"
 },
 {
  "no": "5",
  "name": "Health Promotion",
  "question": "Does your organisation/ company implement programmes that support and maintain worker health and mental well-being?",
  "dr": "DR & IP",
  "guidance": "Check if organisation/ company has at least:\n1) 1 programme to manage the health risks identified in their risk register, and \n\n2) 1 programme to improve health and mental well-being of workers in general (e.g., through health screening and health coaching, healthy diet, active lifestyle, smoking cessation, weight management and stress management)\n\nInterview 3 employees how the above programmes have helped them e.g., by reducing the incidence of ill-health (including mental well-being) and/ or injury",
  "notes": "Attach evidence of health and lifestyle programmes implemented. (e.g., company-organised health screening, health talks)\n\nAttach the interview checklist"
 }
]

export const WSHC_INTERVIEW_QUESTIONS = [
 {
  "ref": "1.1",
  "question": "Do you know where to retrieve the policy and what it means to you."
 },
 {
  "ref": "3.2",
  "question": "Tell me more about the accident(s) that has/ have occurred for this work activity."
 },
 {
  "ref": "3.5",
  "question": "Interview the relevant personnel: Tell me more about how the organisation/ company manages:\n1) the employees workload?\n2) the training plan for new/ existing employees?"
 },
 {
  "ref": "3.6",
  "question": "Interview the relevant personnel: Tell me more about how the organisation/ company takes care of employees, for example:\n1) with individual fitness? (e.g., eyesight, hearing, lack of physical conditioning to carry out heavy lifting or manual work)\n2) with chronic diseases?\n3) with medical condition?\n4) older employees?\n5) who are expecting?\n6) smokers?\n7) alcoholic?"
 },
 {
  "ref": "3.8",
  "question": "Interview the RA/ RM Team: How do you determine severity and likelihood?"
 },
 {
  "ref": "3.10",
  "question": "Are you aware of your appointment and deadline for the implementation?"
 },
 {
  "ref": "3.11",
  "question": "Did you approve the RA for this work activity? Tell me more for your approval criteria."
 },
 {
  "ref": "4.1",
  "question": "Is there a procedure in place that help you determine the implementation status or progress?"
 },
 {
  "ref": "4.2",
  "question": "Tell me more about your implementation plan."
 },
 {
  "ref": "4.3",
  "question": "Are implemented risk controls assessed for their effectiveness post implementation?"
 },
 {
  "ref": "4.4",
  "question": "Can you show me the RA for your work activity?"
 },
 {
  "ref": "4.5",
  "question": "Are you aware of the onsite hazards and the corresponding risk controls implemented?"
 },
 {
  "ref": "4.7",
  "question": "Manager & Supervisor:\nHow do you ensure that your workers adhere to the SWP?\n\nWorker:\nDo you know where to get the copy of the SWP? Do you follow the SWP?"
 },
 {
  "ref": "4.8",
  "question": "Do you know what to do in the event of a terrorism threat?\nTell me more about the terror threat scenario(s) that your organisation/ company has planned for."
 },
 {
  "ref": "5.1",
  "question": "Do you know the criteria to review and revise the RA?"
 },
 {
  "ref": "5.5",
  "question": "Tell me more about the source of your new information and show the impact of new information with at least one recent example."
 },
 {
  "ref": "5.6",
  "question": "Tell me more about the recent changes in the RA for your work activity and how did company communicate and consult your views."
 },
 {
  "ref": "AH 1",
  "question": "Tell me more about your organisation/ company's rewards & performance incentives for drivers"
 },
 {
  "ref": "AH 2",
  "question": "Explain the purpose of LOTO procedure\n\nExplain the purpose of machine guarding"
 },
 {
  "ref": "AH 3",
  "question": "What would you do if you spot a STF hazard?\n\nWhat would you do when you discover that your shoes are worn out?\n"
 },
 {
  "ref": "AH 4",
  "question": "Tell me more about the FPP for the work that you carry out\n\nFor this work activity, where do you hook your safety harness?  "
 },
 {
  "ref": "AH 5",
  "question": "Tell me more about your organisation/ company's health and lifestyle programmes"
 }
]

export const wshcMainByClause = (() => {
  const m = {}
  WSHC_MAIN.forEach(sec => sec.items.forEach(it => { m[it.clause] = it }))
  return m
})()
export const wshcAhByRef = (() => {
  const m = {}
  WSHC_AH.forEach(a => { m['AH' + a.no] = a })
  return m
})()
